module.exports = __webpack_public_path__ + "media/theme/icon__timezone-72fe32ed.svg";